import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { Route, Switch } from "react-router-dom";

import { PageWrapper } from "../../../components/PageWrapper";
import { EARNINGS_PATH } from "../paths";
import { EarningsPage } from "./Page";

export function EarningsContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper>
        <Switch>
          <Route path={`${RootPaths.APP_V2_HOME}/${EARNINGS_PATH}`} component={EarningsPage} />
        </Switch>
      </PageWrapper>
    </ThemeProvider>
  );
}
